import { combineReducers } from 'redux';
import newsAnnouncementDataReducer from './newsAnnouncementDataReducer';
import {tenantDetailsReducer,tenantUserStatusReducer} from './tenantDetailsReducer';
import buildingsReducer from './buildingsReducer';
import derwentBuildingsReducer from './derwentBuildingsReducer';
import spaceReducer from './spaceReducer';

const rootReducer = combineReducers({
  newsAnnouncementDataReducer,
  tenantDetailsReducer,
  tenantUserStatusReducer,
  buildingsReducer,
  derwentBuildingsReducer,
  spaceReducer,
});

export default rootReducer;
